var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { makeObservable, action, observable } from 'mobx';
import { recordingService } from './recording-service';
import { RecordingMode } from '../case-types/models';
var suppportedVideoCodecs = [
    'video/mp4;codecs=h264,aac',
    'video/webm;codecs=vp9,opus',
    'video/webm;codecs=vp8,opus',
    'video/webm;codecs=h264,opus'
];
var suppportedAudioCodecs = [
    'audio/webm'
];
var sliceIntervalMs = 1000;
var uploadIntervalMs = 5000;
var RecordingStore = /** @class */ (function () {
    function RecordingStore() {
        Object.defineProperty(this, "mediaRecorder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "audioContext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recordedBlobs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "caseId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "callId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isUploading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "timer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recordings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "isRecording", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isPaused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isBusy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "durationMs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "mode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        makeObservable(this);
        window.$RecordingStore = this;
    }
    Object.defineProperty(RecordingStore.prototype, "open", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseId, callId) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.caseId = caseId;
                            this.callId = callId;
                            if (!this.caseId) return [3 /*break*/, 2];
                            _a = this.setRecordings;
                            return [4 /*yield*/, recordingService.getUrlsByCaseId(this.caseId)];
                        case 1:
                            _a.apply(this, [_c.sent()]);
                            return [3 /*break*/, 5];
                        case 2:
                            if (!this.callId) return [3 /*break*/, 4];
                            _b = this.setRecordings;
                            return [4 /*yield*/, recordingService.getUrlsByCallId(this.callId)];
                        case 3:
                            _b.apply(this, [_c.sent()]);
                            return [3 /*break*/, 5];
                        case 4:
                            this.setRecordings([]);
                            _c.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "close", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.caseId = undefined;
            this.callId = undefined;
            this.setRecordings([]);
        }
    });
    Object.defineProperty(RecordingStore.prototype, "setRecordings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (recordings) {
            this.recordings = recordings;
        }
    });
    Object.defineProperty(RecordingStore.prototype, "setDuration", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (durationMs) {
            this.durationMs = durationMs;
        }
    });
    Object.defineProperty(RecordingStore.prototype, "startRecording", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (callId, remoteStream, localStream, mode) {
            var _this = this;
            try {
                if (this.isRecording)
                    return false;
                var codec = this.getCodec();
                if (!codec)
                    return false;
                if (!this.audioContext) {
                    this.audioContext = this.createAudioContext();
                    if (!this.audioContext)
                        return false;
                }
                this.recordedBlobs = [];
                this.callId = callId;
                this.mode = mode;
                var mixedStream = this.getMixedStream(remoteStream, localStream);
                if (!mixedStream)
                    return false;
                this.mediaRecorder = new MediaRecorder(mixedStream, { mimeType: codec });
                this.mediaRecorder.ondataavailable = function (e) { return _this.onDataAvailable(e); };
                this.mediaRecorder.onstop = function (e) { return _this.onStop(e); };
                this.timer = setInterval(function () { return _this.onTimer(); }, uploadIntervalMs);
                this.mediaRecorder.start(sliceIntervalMs);
                this.isRecording = true;
                this.isPaused = false;
                this.setDuration(0);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        }
    });
    Object.defineProperty(RecordingStore.prototype, "pauseRecording", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.isRecording)
                                return [2 /*return*/];
                            if (!this.mediaRecorder)
                                return [2 /*return*/];
                            this.mediaRecorder.pause();
                            this.isPaused = true;
                            return [4 /*yield*/, this.refreshCurrentCallVideo()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "resumeRecording", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isRecording)
                return;
            if (!this.mediaRecorder)
                return;
            this.mediaRecorder.resume();
            this.isPaused = false;
        }
    });
    Object.defineProperty(RecordingStore.prototype, "stopRecording", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.isRecording)
                                return [2 /*return*/];
                            if (!this.mediaRecorder)
                                return [2 /*return*/];
                            this.mediaRecorder.stop();
                            this.mediaRecorder = undefined;
                            //this.streamMixer.releaseStreams();
                            //this.streamMixer = undefined;
                            this.isRecording = false;
                            this.isPaused = false;
                            return [4 /*yield*/, this.refreshCurrentCallVideo()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "onStop", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.uploadBlobs()];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.refreshCurrentCallVideo()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "getCodec", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var first = this.getSupportedCodecs()[0];
            return first;
        }
    });
    Object.defineProperty(RecordingStore.prototype, "getSupportedCodecs", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.mode === RecordingMode.Video) {
                return suppportedVideoCodecs.filter(function (mimeType) {
                    return MediaRecorder.isTypeSupported(mimeType);
                });
            }
            else {
                return suppportedAudioCodecs.filter(function (mimeType) {
                    return MediaRecorder.isTypeSupported(mimeType);
                });
            }
        }
    });
    Object.defineProperty(RecordingStore.prototype, "onDataAvailable", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            this.recordedBlobs.push(e.data);
            this.setDuration(this.durationMs + sliceIntervalMs);
        }
    });
    Object.defineProperty(RecordingStore.prototype, "onTimer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.uploadBlobs()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "uploadBlobs", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var blob;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.isUploading)
                                return [2 /*return*/];
                            if (!this.isRecording) {
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                            if (!(this.recordedBlobs.length > 0)) return [3 /*break*/, 4];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            this.isUploading = true;
                            blob = new Blob(this.recordedBlobs);
                            this.recordedBlobs = [];
                            return [4 /*yield*/, recordingService.upload(this.callId, blob, this.durationMs, this.mode)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            this.isUploading = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (attachmentId) {
            return __awaiter(this, void 0, void 0, function () {
                var videos;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, recordingService.delete(attachmentId)];
                        case 1:
                            _a.sent();
                            videos = this.recordings.filter(function (v) { return v.id !== attachmentId; });
                            this.setRecordings(videos);
                            if (this.isRecording)
                                this.setDuration(0);
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "refreshCurrentCallVideo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.callId)
                                return [2 /*return*/];
                            this.setIsBusy(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 4, 5]);
                            // Let video be fully uploaded
                            return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, uploadIntervalMs / 2); })];
                        case 2:
                            // Let video be fully uploaded
                            _b.sent();
                            _a = this.setRecordings;
                            return [4 /*yield*/, recordingService.getUrlsByCallId(this.callId)];
                        case 3:
                            _a.apply(this, [_b.sent()]);
                            return [3 /*break*/, 5];
                        case 4:
                            this.setIsBusy(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(RecordingStore.prototype, "setIsBusy", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isBusy) {
            this.isBusy = isBusy;
        }
    });
    Object.defineProperty(RecordingStore.prototype, "getMixedStream", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (remoteStream, localStream) {
            if (this.mode === RecordingMode.Video) {
                var remoteVideoTracks = remoteStream.getVideoTracks();
                var remoteAudioTracks = remoteStream.getAudioTracks();
                var localAudioTracks = localStream.getAudioTracks();
                if (remoteVideoTracks.length === 0)
                    return undefined;
                if (remoteAudioTracks.length === 0)
                    return undefined;
                if (localAudioTracks.length === 0)
                    return undefined;
                var videoTrack = remoteVideoTracks[0];
                var audioStream = this.getMixedAudioStream(remoteAudioTracks[0], localStream);
                if (!audioStream)
                    return undefined;
                var mixedStream = new MediaStream([videoTrack, audioStream.getAudioTracks()[0]]);
                return mixedStream;
            }
            else if (this.mode === RecordingMode.Audio) {
                var remoteAudioTracks = remoteStream.getAudioTracks();
                var localAudioTracks = localStream.getAudioTracks();
                if (remoteAudioTracks.length === 0)
                    return undefined;
                if (localAudioTracks.length === 0)
                    return undefined;
                var mixedStream = new MediaStream([remoteAudioTracks[0], localAudioTracks[0]]);
                return mixedStream;
            }
        }
    });
    Object.defineProperty(RecordingStore.prototype, "getMixedAudioStream", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (remoteAudioTrack, localStream) {
            if (!this.audioContext)
                return undefined;
            var remoteSource = this.audioContext.createMediaStreamSource(new MediaStream([remoteAudioTrack]));
            var localSource = this.audioContext.createMediaStreamSource(localStream);
            var destination = this.audioContext.createMediaStreamDestination();
            remoteSource.connect(destination);
            localSource.connect(destination);
            return destination.stream;
        }
    });
    Object.defineProperty(RecordingStore.prototype, "createAudioContext", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var wnd = window;
            if (typeof AudioContext !== 'undefined') {
                return new AudioContext();
            }
            else if (typeof wnd.webkitAudioContext !== 'undefined') {
                return new wnd.webkitAudioContext();
            }
            else if (typeof wnd.mozAudioContext !== 'undefined') {
                return new wnd.mozAudioContext();
            }
            return undefined;
        }
    });
    __decorate([
        observable
    ], RecordingStore.prototype, "recordings", void 0);
    __decorate([
        observable
    ], RecordingStore.prototype, "isRecording", void 0);
    __decorate([
        observable
    ], RecordingStore.prototype, "isPaused", void 0);
    __decorate([
        observable
    ], RecordingStore.prototype, "isBusy", void 0);
    __decorate([
        observable
    ], RecordingStore.prototype, "durationMs", void 0);
    __decorate([
        observable
    ], RecordingStore.prototype, "mode", void 0);
    __decorate([
        action
    ], RecordingStore.prototype, "open", null);
    __decorate([
        action
    ], RecordingStore.prototype, "close", null);
    __decorate([
        action
    ], RecordingStore.prototype, "setRecordings", null);
    __decorate([
        action
    ], RecordingStore.prototype, "setDuration", null);
    __decorate([
        action
    ], RecordingStore.prototype, "startRecording", null);
    __decorate([
        action
    ], RecordingStore.prototype, "pauseRecording", null);
    __decorate([
        action
    ], RecordingStore.prototype, "resumeRecording", null);
    __decorate([
        action
    ], RecordingStore.prototype, "stopRecording", null);
    __decorate([
        action
    ], RecordingStore.prototype, "setIsBusy", null);
    return RecordingStore;
}());
export default RecordingStore;
